import axios from 'axios';
import { EventBus } from '../event/event-bus.js';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (method === "put" || method === "delete") {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    //Menus
    async getOperatorMenus(accessToken) {
        return await this.execute('get', `/menu`, null, accessToken);
    },

}
